import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import dotProp from "dot-prop-immutable"
import _ from "lodash"

import { MDB_TYPES as TYPES } from "@meddbriefer/scenario-data/constants.js"
import { useFirebase } from '@meddbriefer/mdb-firebase';
import { getScenarioByID } from '@meddbriefer/scenario-data';

import { useScenarioEditor } from './ScenarioEditorContext';
import { applyFieldDefaultValue, trimFieldValue, ignoreTrailingSpaceInStrings } from './formUtils';

import ScenarioItem from "./ScenarioItem.js";
import SaveButton from '../ScenarioTypeEditor/SaveButton';

const UNWANTED_CHECKLIST_TYPES = [TYPES.AWO, TYPES.CL_PROMPT, TYPES.DECISION, TYPES.DECISION_OPTION, TYPES.REQURED]


export default function Steplist() {
	const {db} = useFirebase()
	const {scenarioId} = useParams()
	const {scenario, saveScenario, updateScenarioFld, scenarioType} = useScenarioEditor()
	const [steps, setSteps] = useState(null)
	const [state, setState] = useState(null)
	const [origState, setOrigState] = useState(null)
	const [stateUpdated, setStateUpdated] = useState(false)
	const [hasChanges, setHasChanges] = useState(false)
	const [readyToSave, setReadyToSave] = useState(false)

	const cleanFieldValues = () => {
		let cleanedValues = {...state}
		Object.keys(state.assessmentFindings).forEach(fld => {
			const fldPath = `assessmentFindings.${fld}`
			cleanedValues = applyFieldDefaultValue(cleanedValues, fldPath, "unremarkable")
			cleanedValues = trimFieldValue(cleanedValues, fldPath)
		})
		if (! _.isEqual(state, cleanedValues)) {
			// some fields were cleaned, update state in one fell swoop
			setState(cleanedValues)
		}
	}

	const saveHandler = (event) => {
		cleanFieldValues()
		setReadyToSave(true)
	}

	const changeHandler = (event) => {
		const {id: fldPath, value} = event.target
		setState(dotProp.set(state, fldPath, value))
		setStateUpdated(true)
	}

	useEffect(
		() => {
			if (!steps) {
				// this *should* only run on initial render

				// filter out checklist items, other than PHASEs and SUB_PHASEs
				// (for headings) which don't have findings
				const tmp = scenarioType.checkListMetaData
								.filter(rec => !UNWANTED_CHECKLIST_TYPES.includes(rec.type))
				setSteps(tmp)
				const tmp2 = {assessmentFindings: scenario.assessmentFindings}
				setState(tmp2)
				setOrigState(tmp2)
			}
		}, [scenarioId, steps, scenario, scenarioType]
	)

	useEffect(
		() => {
			if (stateUpdated) {
				setStateUpdated(false)
				if (! _.isEqualWith(state, origState, ignoreTrailingSpaceInStrings)) {
					setHasChanges(true)
				}
			}
		}, [stateUpdated, state, origState]
	)


	useEffect(
		() => {
			if (readyToSave) {
				// prevent endless loop with firebase changes
				setReadyToSave(false)
				//copy over our local state changes to scenario
				updateScenarioFld("assessmentFindings", state.assessmentFindings)
				// set things up so we don't have any changes anymore
				setOrigState(state)
				setHasChanges(false)
				//persist changes to the db
				const saveToDB = async () => {
					// we only want to persist changes to this form's local state
					const scenData = {
						...await getScenarioByID(db, scenarioId),
						assessmentFindings: state.assessmentFindings
					}
					await saveScenario(scenData)
				}
				saveToDB()
			}
		}, [db, readyToSave, state, origState, scenarioId, saveScenario, updateScenarioFld]
	)

	if (!steps) {
		return (<div>Loading...</div>)
	}
	return (
		<div className='scenario-form-wrapper'>
			<SaveButton label="Save changes to Findings" haveChanges={hasChanges} clickHandler={saveHandler}/>
			<div className="scenario-form">
				<div id="scenario-steps">
					<h1>Assessment step findings</h1>
					{steps.map(item =>
						<ScenarioItem
							key={item.id}
							item={item}
							scenario={state}
							changeHandler={changeHandler}
						/>
					)}
				</div>
			</div>
			<SaveButton label="Save changes to Findings" haveChanges={hasChanges} clickHandler={saveHandler}/>
		</div>
	);
};